// src/utils/globalSync.js
let _id = 0;
const fire = (detail) =>
  window.dispatchEvent(new CustomEvent('global-sync', { detail }));

export function beginGlobalSync(detail = {}) {
  const id = ++_id;
  fire({ type: 'start', id, ...detail });
  return id;
}

export function updateGlobalSync(id, progress, detail = {}) {
  fire({ type: 'update', id, progress, ...detail }); // 0..1 or null
}

export function endGlobalSync(id, detail = {}) {
  fire({ type: 'end', id, ...detail });
}

// Convenience wrapper
export async function withGlobalSync(promiseOrFn, onTick) {
  const id = beginGlobalSync();
  try {
    const run = typeof promiseOrFn === 'function' ? promiseOrFn : () => promiseOrFn;
    const result = await run((p) => {
      if (typeof onTick === 'function') onTick(p);
      updateGlobalSync(id, p);
    });
    updateGlobalSync(id, 1);
    return result;
  } finally {
    endGlobalSync(id);
  }
}
